import { InitializeAddUsersRequestSchema, InitializeAddUsersResponseSchema } from './initialize-add-users.schema';
/**
 * Add Users Bulk Endpoint Contract
 * Bulk create users in the organizational hierarchy
 * Restricted to authorized users only
 */ export const InitializeAddUsersContract = {
    method: 'POST',
    path: '/api/v2/initialize/users',
    description: 'Bulk create users',
    requestSchema: InitializeAddUsersRequestSchema,
    responseSchema: InitializeAddUsersResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-add-users.contract.js.map